import * as React from 'react'

const MOBILE_BREAKPOINT = 1024

export function useIsMobile(mobile_breakpoint?: number) {
  const breakpoint = mobile_breakpoint ?? MOBILE_BREAKPOINT
  // isMobile의 초기 값을 undefined로 정의. boolean으로 초기화 하면 서버 렌더링과 클라이언트 렌더링 시 DOM 값이 달라 오류 발생
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    // matchMedia : css 미디어 쿼리를 JavaScript에서 사용할 수 있게 해주는 웹 API
    const mql = window.matchMedia(`(max-width: ${breakpoint}px)`) // 1024px 이하면 true
    const onChange = () => setIsMobile(mql.matches) // 미디어 쿼리 값이 현재 만족하는지를 나타내는 boolean 값

    setIsMobile(mql.matches)
    mql.addEventListener('change', onChange)

    return () => mql.removeEventListener('change', onChange)
  }, [breakpoint])

  return isMobile
}
